'use client';

import {useMenu} from '@/context/MenuContext';

export default function HtmlContent({html, mobile}: {html: any; mobile: any}) {
  const {hideMenu} = useMenu();
  if (!mobile) {
    return (
      <>
        <div onMouseEnter={() => hideMenu()}>{html}</div>
      </>
    );
  } else {
    return (
      <>
        <div className="hidden md:block" onMouseEnter={() => hideMenu()}>
          {html}
        </div>
        <div className="md:hidden" onMouseEnter={() => hideMenu()}>
          {mobile ?? html}
        </div>
      </>
    );
  }
}
